var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18.5C1.95 18.5 1.47933 18.3043 1.088 17.913C0.696667 17.5217 0.500667 17.0507 0.5 16.5V2.5C0.5 1.95 0.696 1.47933 1.088 1.088C1.48 0.696667 1.95067 0.500667 2.5 0.5H16.5C17.05 0.5 17.521 0.696 17.913 1.088C18.305 1.48 18.5007 1.95067 18.5 2.5V9.2C18.1833 9.05 17.8583 8.921 17.525 8.813C17.1917 8.705 16.85 8.62567 16.5 8.575V2.5H2.5V16.5H8.55C8.6 16.8667 8.67933 17.2167 8.788 17.55C8.89667 17.8833 9.02567 18.2 9.175 18.5H2.5ZM2.5 15.5V16.5V2.5V8.575V8.5V15.5ZM4.5 14.5H8.575C8.625 14.15 8.70433 13.8083 8.813 13.475C8.92167 13.1417 9.04233 12.8167 9.175 12.5H4.5V14.5ZM4.5 10.5H10.6C11.1333 10 11.7293 9.58333 12.388 9.25C13.0467 8.91667 13.7507 8.69167 14.5 8.575V8.5H4.5V10.5ZM4.5 6.5H14.5V4.5H4.5V6.5ZM15.5 20.5C14.1167 20.5 12.9377 20.0123 11.963 19.037C10.9883 18.0617 10.5007 16.8827 10.5 15.5C10.5 14.1167 10.9877 12.9377 11.963 11.963C12.9383 10.9883 14.1173 10.5007 15.5 10.5C16.8833 10.5 18.0627 10.9877 19.038 11.963C20.0133 12.9383 20.5007 14.1173 20.5 15.5C20.5 16.8833 20.0123 18.0627 19.037 19.038C18.0617 20.0133 16.8827 20.5007 15.5 20.5ZM15 18.5H16V16H18.5V15H16V12.5H15V15H12.5V16H15V18.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotes);
export default __webpack_public_path__ + "static/media/no-notes.825879f942e6d99873be38ac722a9dd2.svg";
export { ForwardRef as ReactComponent };